import {gql} from '@apollo/client';

export const PROCEDURE_RUN_PLANS_QUERY = gql`
  query ProcedureRunPlansMapping($ids: [StrictString!]!) @skipAudit @engComponent(name: LLM) {
    procedureRunPlans(ids: $ids) {
      ... on ProcedureRunPlanNode {
        id
        procedureFlowchartConfigVersionProxy {
          ... on ProcedureFlowchartConfigVersionProxyNode {
            id
            procedure {
              id
              procedureType
            }
          }
        }
      }
    }
  }
`;

export const STUDY_TYPE_QUERY = gql`
  query StudyTypeMapping($ids: [StrictString!]!) @skipAudit @engComponent(name: LLM) {
    studies(ids: $ids) {
      ... on StudyNode {
        id
        studySchema {
          id
          studyType
        }
      }
    }
  }
`;
